"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactstrap = require("reactstrap");

var _config = _interopRequireDefault(require("@dom/config"));

var FacebookLogin =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(FacebookLogin, _Component);

  function FacebookLogin() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, FacebookLogin);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(FacebookLogin)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      isSdkLoaded: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "signIn", function () {
      return window.FB && window.FB.login(function (response) {
        if (response.status === 'connected') {
          var accessToken = response.authResponse.accessToken;
          window.FB.api('/me', {
            fields: 'email,name,picture'
          }, function (response) {
            return _this.props.submit(_this.makeApiData(response, accessToken));
          });
        }
      }, {
        scope: 'email,public_profile'
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "makeApiData", function (_ref, accessToken) {
      var email = _ref.email;
      return {
        email: email,
        accessToken: accessToken,
        provider: 'facebook'
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "loadFacebookSdk", function () {
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: _config["default"].facebook,
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v2.11'
        }); // change the state when FB object is ready

        _this.setState({
          isSdkLoaded: true
        });
      };

      (function (d, s, id) {
        var js;
        var fjs = d.getElementsByTagName(s)[0];

        if (d.getElementById(id)) {
          return;
        }

        js = d.createElement(s);
        js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    });
    return _this;
  }

  (0, _createClass2["default"])(FacebookLogin, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(_reactstrap.Button, {
        color: "facebook",
        className: this.props.loading ? 'btn-login btn-loading btn-social' : 'btn-social' // For loading animations
        ,
        onClick: this.signIn,
        disabled: !this.state.isSdkLoaded
      }, this.props.buttonText);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var isFbSdkLoaded = !!document.getElementById('facebook-jssdk');

      if (isFbSdkLoaded) {
        this.setState({
          isSdkLoaded: true
        });
        return;
      }

      this.loadFacebookSdk();
    }
  }]);
  return FacebookLogin;
}(_react.Component);

exports["default"] = FacebookLogin;
(0, _defineProperty2["default"])(FacebookLogin, "defaultProps", {
  buttonText: 'Sign up with Facebook'
});